<template>
    <a-modal destroyOnClose wrap-class-name="modal-content" width="90%" style="max-width: 500px" :maskClosable="true" v-model:open="modal.visible" :title="`${$t('l_Admin')}: ${userInfo.jpID ?? ''}`" :centered="false" :confirm-loading="modal.confirmLoading" :afterClose="closeModal">
        <div>
            <div style="width: 100%" class="align-center mt-4 mb-8">
                <a-input ref="inputRef" v-model:value.trim="info.fullName" :placeholder="$t('l_Name_fill')" @pressEnter="onSubmit()"></a-input>
            </div>
        </div>
        <template #footer>
            <a-button type="primary" :loading="modal.confirmLoading" @click="onSubmit()">
                {{ $t("l_Save") }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
import http from "@/utils/http"
import { message } from "ant-design-vue"
import config from "@/config"
import { mapGetters, mapMutations } from "vuex"

export default {
    name: "FillInOperatorInfo",
    emits: ["confirm"],
    components: {},
    data() {
        return {
            modal: {
                visible: false,
                confirmLoading: false,
            },
            info: {},
        }
    },
    computed: {
        ...mapGetters({
            userInfo: "userInfo",
        }),
    },
    methods: {
        ...mapMutations({
            updateAdminInfoStore: "updateAdminInfo",
        }),
        onSubmit() {
            if (!this.info.fullName) {
                return
            }
            http({
                url: config.nakedBaseURL + "order_service/protected/admin/fill-name?jpid=" + this.userInfo.jpID,
                data: {
                    fullName: this.info.fullName,
                },
            }).then((res) => {
                if (res.status == 0) {
                    this.updateAdminInfo()
                    message.success(this.$t("l_Succeed"))
                    this.modal.visible = false
                }
            })
        },
        async updateAdminInfo() {
            if (!this.userInfo.jpID) return

            const res = await http({
                url: config.nakedBaseURL + "order_service/protected/admin/info?jpid=" + this.userInfo.jpID,
            })
            if (res.status == 0) {
                this.updateAdminInfoStore(res.data)
            }
        },
        show() {
            this.modal.visible = true
            setTimeout(() => {
                this.$refs.inputRef.focus()
            }, 200)
        },
        closeModal() {
            this.info = {}
        },
    },
}
</script>
